import { Conversation } from "types";
import { ResourceFetchOptions, useResource } from "../useResource";

export const useConversation = (conversationId?: ID, options: ResourceFetchOptions<Conversation> = {}) => {
    const response = useResource<Conversation>(["conversations", conversationId], null, options);

    return { ...response, conversation: response.data, isLoadingConversation: response.isLoading };
};
